// extracted by mini-css-extract-plugin
module.exports = {"svg-icon":"SvgIcon_svg-icon_-HVN5","svg":"SvgIcon_svg_2UTSi"};